import React, {PropsWithChildren} from "react";
import {get} from "lodash";
import styled from "@emotion/styled";
import {useTranslation} from "react-i18next";
import {Language} from "modules/enums";
import {breakpoints, fieldsImages} from "assets/theme";

const Wrapper = styled.div`
	position: relative;
	width: 100%;

	@media (min-width: ${breakpoints.tablet}) {
		background: none;
	}
`;

const FieldImage = styled.img`
	width: 100%;
	height: 100%;
	max-height: 770px;
`;

const PlayersWrapper = styled.div`
	position: absolute;
	left: 0;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
`;

export const VoteField: React.FC<PropsWithChildren> = ({children}) => {
	const {i18n} = useTranslation();
	const language = i18n.language as Language;
	const fieldImage = get(fieldsImages, language, "");

	return (
		<Wrapper>
			<FieldImage className="field-image" src={fieldImage} alt="Field Image" />

			<PlayersWrapper>{children}</PlayersWrapper>
		</Wrapper>
	);
};
